import { createContext } from "preact";
export var SoaContext = createContext({});
